<template>
  <div class="wg-row">
    <template v-if="importOtherContact">
      <div class="com-anm22-app-text-m">
        {{ $anm22.strLang(lang, "Contacts", "Contatti") }}
      </div>
      <div class="vertical-height-div" style="height: 5px"></div>
      <wg-search
        :mode="'offline'"
        :searchFn="searchContact"
        :clickFn="selectContact"
        :filters="searchFilters"
        :debounceTime="1000"
      ></wg-search>
      <div class="vertical-height-div" style="height: 15px"></div>
      <div class="wg-col wg-xs-12" v-if="contactSelected">
          <div class="vertical-height-div" style="height: 15px"></div>
          <div
            class="wg-row display-flex"
            style="align-items: center; min-height: 50px"
          >
            <img
              style="width: 30px"
              :src="$anm22.icons.getWorldIcon('menuContactsBlue')"
            />
            <div class="anm22-calendar-field-inline">
              {{ $anm22.getContactName($store.getters['contacts/get'](contactSelected), $store) }}
            </div>
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="cursor: pointer; margin-left: 5px"
              @click="contactSelected = 0"
            />
          </div>
        </div>
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Back ', 'Indietro')"
        @click="importOtherContact = false"
      />
      <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
      <input
        type="button"
        :style="{ opacity: !canImportInContacts ? '0.7' : '' }"
        :disabled="!canImportInContacts"
        :value="$anm22.strLang(lang, 'Import ', 'Importa')"
        @click="importFeedInContact"
      />
    </template>
    <template v-else>
      <div class="wg-col wg-xs-12 wg-sm-12">
        <div class="com-anm22-app-text-m">
          {{
            selectAllProjects
              ? $anm22.strLang(lang, "All projects", "Tutti i progetti")
              : $anm22.strLang(lang, "Contacts projects", "Progetti contatto ")
          }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <select class="com-anm22-app-select" v-model="projectRef">
          <option value="0">Nessun progetto selezionato</option>
          <template v-if="!selectAllProjects">
            <option
              v-for="(project, index) in customerProjectsToAdd"
              :key="'project-' + index"
              :value="project.idWorldProject"
            >
              <span>{{
                project.projectId
                  ? project.projectId + " - " + project.name
                  : project.name
              }}</span>
            </option>
          </template>
          <template v-else>
            <option
              v-for="(project, index) in projectsToAdd"
              :key="'project-' + index"
              :value="project.idWorldProject"
            >
              <span>{{
                project.projectId
                  ? project.projectId + " - " + project.name
                  : project.name
              }}</span>
            </option>
          </template>
        </select>
      </div>
      <div class="vertical-height-div" style="height: 15px"></div>
      <input
        type="button"
        :value="
          $anm22.strLang(
            lang,
            'Share in other contact',
            'Condividi in un altro contatto'
          )
        "
        @click="importOtherContact = true"
      />
      <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
      <input
        v-if="!selectAllProjects"
        type="button"
        :value="
          $anm22.strLang(lang, 'Other projects ', 'Scegli altri progetti')
        "
        @click="selectAllProjects = true"
      />
      <input
        v-else
        type="button"
        :value="$anm22.strLang(lang, 'Contacts Projects ', 'Progetti contatto')"
        @click="selectAllProjects = false"
      />
      <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
      <input
        type="button"
        :style="{ opacity: !canImport ? '0.7' : '' }"
        :disabled="!canImport"
        :value="$anm22.strLang(lang, 'Share ', 'Condividi')"
        @click="importFeed"
      />
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    contactId: [String, Number],
    msg: Object,
  },
  data() {
    return {
      showContact:false,
      selectAllProjects: false,
      projectRef: 0,
      contactSelected: 0,
      importOtherContact: false,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    searchFilters() {
      return [(contact) => this.contact.idContactsContact != contact.id];
    },
    customerProjects() {
      return this.$store.getters["projects/getByCustomer"](
        this.contact.idContactsContact
      );
    },
    projects() {
      return this.$store.getters["projects/getAll"];
    },
    boardFeedAssoc() {
      return this.$store.getters["feedBoardAssocs/getByContactMessage"](
        this.msg.idWorldMessage
      );
    },
    customersToAdd() {
      let contacts = this.$store.getters["contacts/getAll"].filter(
        (c) => c && c.workOwner == this.contact.workOwner
      );
      return contacts;
    },
    //Progetti ancora disponibili per l'importazione
    projectsToAdd() {
      let result = [];
      this.projects.forEach((p) => {
        let associated = false;
        this.boardFeedAssoc.forEach((assoc) => {
          if (p.idWorldProject == assoc.project) {
            associated = true;
          }
        });
        if (!associated) {
          result.push(p);
        }
      });
      return result;
    },
    //Progetti contatto ancora disponibili per l'importazione
    customerProjectsToAdd() {
      let result = [];
      this.customerProjects.forEach((p) => {
        let associated = false;
        this.boardFeedAssoc.forEach((assoc) => {
          if (p.idWorldProject == assoc.project) {
            associated = true;
          }
        });
        if (!associated) {
          result.push(p);
        }
      });
      return result;
    },
    canImport() {
      if (this.projectRef == 0) {
        return false;
      }
      return true;
    },
    canImportInContacts() {
      if(this.contactSelected == 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    searchContact(string) {
      const regexp = new RegExp(string, "i");
      return this.customersToAdd
        .filter((c) => {
          return -1 !== (c.firstName + " " + c.lastName).search(regexp);
        })
        .map((c) => {
          const fullname = c.firstName + " " + c.lastName;
          return {
            label: fullname,
            id: c.idContactsContact,
          };
        });
    },
    selectContact(idContact) {
      this.contactSelected = idContact;
      this.showContact = true;
    },
    importFeedInContact() {
      this.$http
        .post("contact/contact-import-feed", {
          msg: this.msg,
          contactId: this.contactSelected
        }, {
          withCredentials: true
        })
        .then((response) => {
          Promise.all([
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: [response.data.msg],
            }),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact],
            })
          ]);
          this.$Progress.finish();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => console.log(error));
    },
    importFeed() {
      this.$http
        .post("contact/import", {
          projectId: this.projectRef,
          msg: this.msg,
          contactId: this.contact.idContactsContact
        }, {
          withCredentials: true
        })
        .then((response) => {
          Promise.all([
            this.$store.dispatch("feedBoardAssocs/update", {
              vlf: this.$vlf("feedBoardAssocs"),
              objs: [response.data.assoc],
            }),
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: [response.data.msgBoard],
            }),
          ]);
          this.$Progress.finish();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch((error) => console.log(error));
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
